import { useState, useEffect } from 'react';
import { TermsPolicyDetailPage } from './buyer/TermsPolicyDetailPage';
import { DesktopTermsPolicyDetailPage } from './desktop/DesktopTermsPolicyDetailPage';

export function ResponsiveTermsPolicyDetailPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <TermsPolicyDetailPage /> : <DesktopTermsPolicyDetailPage />;
}